export const INITIAL_STATE_WALLET_ONBOARDED = {
  step: 'wallet_connected_idle',
  kind: 'metamask',
  ethereumAddress: '0xC20B28937b11111111111111111111111d605a68',
  starknetAddress:
    '0x79030d1b21111111111111111111111111111111111111112807c88da8787a2',
  isOnboarded: true,
  error: '',
} as const;
